import { useCallback } from 'react';

export const useFileValidation = (maxSelect, whitelistExtensions)=>{
  const validateSelection = useCallback((selectedFiles) => {
    const errors = [];

    if (maxSelect !== null && selectedFiles.length > maxSelect) {
      errors.push(`You can select up to ${maxSelect} files.`);
    }

    if (whitelistExtensions !== null) {
      const invalidFiles = selectedFiles.filter(file => {
        const extension = file.split('.').pop().toLowerCase();
        return !whitelistExtensions.includes(extension);
      });

      if (invalidFiles.length > 0) {
        errors.push(`Some files have extensions not allowed. Allowed extensions: ${whitelistExtensions.join(', ')}.`);
      }
    }

    return errors;
  }, [maxSelect, whitelistExtensions]);

  return { validateSelection };
}
